import React, { useEffect } from "react";
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";
import { useMandatorContext } from "@rentablo/theming";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";
import NightIcon from "@icons/myicons/night.svg?react";

type Props = {};

export const ThemeModSwitch = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const changeMode = searchParams.get("changeMode");
  const { mode, setMode } = useMandatorContext();

  useEffect(() => {
    if (changeMode === "true") {
      setTimeout(() => {
        setMode("dark");
        navigate("/settings/profile", { replace: true });
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeMode]);

  return (
    <Box mt={7.5}>
      <Typography
        variant="overline"
        color="textSecondary"
        textTransform="uppercase"
        mb={3.5}
        ml={2}
      >
        {t("settings.sidebar.themeMode.title")}
      </Typography>
      <Box display="flex" alignItems="center" gap={1.5} ml={1.5}>
        <NightIcon color={theme.palette.icon.secondary} />
        <FormControlLabel
          control={
            <Switch
              checked={mode === "dark"}
              onChange={() => setMode(mode === "light" ? "dark" : "light")}
              color="primary"
            />
          }
          sx={{ marginLeft: 0 }}
          label={t("settings.sidebar.themeMode.dark")}
        />
      </Box>
    </Box>
  );
};
